// extracted by mini-css-extract-plugin
export default {"glass":"Login_glass__+VnhA","profile_img":"Login_profile_img__EnSal","textbox":"Login_textbox__nRrH5","btn":"Login_btn__pALc8","logo":"Login_logo__q1eJV"};